module.exports = __webpack_public_path__ + "img/Aktivierung_tall.6d2491d9.jpg";